<template>
  <single-vehicle />
</template>

<script>
import SingleVehicle from "@/components/3pl/Settings/Vehicles/SingleVehicle/index";
export default {
  components: {
    SingleVehicle,
  },
};
</script>
y<style></style>
